import React from "react";
import {IconButton} from "@mui/material";
import {useTheme} from "../../../../contexts/theme";


const StyledIconButton = ({onBlur, children, onClick, width, onFocus, disabled, height, ignoreSpacePress = false}) => {

    const theme = useTheme();

    return (
        <IconButton
            onClick={onClick}
            onKeyDown={ignoreSpacePress ? onClick :  (event) => {
                if (event.key === ' ' || event.key === 'Spacebar') {
                    // Prevent spacebar from triggering click
                    event.preventDefault();
                }
            }}
            onFocus={onFocus}
            onBlur={onBlur}
            disabled={disabled}
            sx={{
                backgroundColor: 'transparent',
                color: theme.palette.white,
                border: `${theme.border.type.solid} ${theme.border.width.medium} ${theme.palette.lightGrey}`,
                borderRadius: theme.border.radius.md,
                transition: 'background-color 0.5s',
                height: height ? height : "40px",
                padding: theme.spacing.sm,
                textTransform: 'none',
                width: width ? width : 'auto',
                '&:hover': {
                    backgroundColor: theme.palette.orange,
                    borderColor: theme.palette.orange,
                },
                '&:disabled': {
                    borderColor: theme.palette.lightGrey,
                    color: theme.palette.lightGrey,
                },
            }}
        >
            {children}
        </IconButton>
    );

}

export default StyledIconButton;